export default "<div class=\"map-container\">\n\t\t<div id=\"{{$ctrl.map_id}}\" class=\"map\"><h3>{{$ctrl.message}}</h3></div>\n</div>";